var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bg-fade"}},[(_vm.visible)?_c('div',{staticClass:"global-loader-overlay",attrs:{"aria-busy":"true","role":"status"}},[_c('div',{staticClass:"global-loader-spinner"},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.loadingLabel))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }